import { useState } from "react";

function Faq() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    leavingFrom: "",
    goingTo: "",
    carType: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    // You can add API call or other submission logic here
    alert("Request submitted! We will call you back soon.");

    // Reset form
    setFormData({
      name: "",
      phone: "",
      leavingFrom: "",
      goingTo: "",
      carType: ""
    });
  };

  const handleCallNow = (actionLink) => {
    window.open(actionLink, '_blank');
  };


  return (
    <>
      <section className="callback-section">
        <div className="container">
          <div className="callback-container">
            {/* Left Column - Request a call back form */}
            <div className="callback-form-column">
              <div className="callback-form-wrap">
                <div className="callback-form-title">
                  <h3>Request a call back</h3>
                </div>
                <div className="callback-form-description">
                  <p>Get in touch with us today for all your travel needs.</p>
                </div>
                <div className="callback-form-container">
                  <form onSubmit={handleSubmit} className="callback-form">
                    <div className="form-field">
                      <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleInputChange}
                        maxLength="400"
                        className="form-control"
                      />
                    </div>
                    <div className="form-field">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleInputChange}
                        maxLength="10"
                        minLength="10"
                        required
                        className="form-control"
                      />
                    </div>
                    <div className="form-field">
                      <input
                        type="text"
                        name="leavingFrom"
                        placeholder="Leaving From"
                        value={formData.leavingFrom}
                        onChange={handleInputChange}
                        maxLength="400"
                        required
                        className="form-control"
                      />
                    </div>
                    <div className="form-field">
                      <input
                        type="text"
                        name="goingTo"
                        placeholder="Going to"
                        value={formData.goingTo}
                        onChange={handleInputChange}
                        maxLength="400"
                        required
                        className="form-control"
                      />
                    </div>
                    <div className="form-field">
                      <select
                        name="carType"
                        value={formData.carType}
                        onChange={handleInputChange}
                        required
                        className="form-control"
                      >
                        <option value="">Select a Car</option>
                        <option value="Toyota Rumion">Toyota Rumion</option>
                        <option value="Maruti Suzuki Ertiga">Maruti Suzuki Ertiga</option>
                        <option value="Maruti Suzuki Dzire">Maruti Suzuki Dzire</option>
                        <option value="Hyundai Aura">Hyundai Aura</option>
                        <option value="Maruti Suzuki Wagon R">Maruti Suzuki Wagon R</option>
                        <option value="Innova Crysta">Innova Crysta</option>
                      </select>
                    </div>
                    <div className="form-field">
                      <button
                        type="submit"
                        className="submit-btn"
                        id="requestacallback"
                        onClick={() => handleCallNow('https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab')}
                      >
                        Request A CallBack
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Right Column - Get in touch */}
            <div className="callback-info-column">
              <div className="callback-info-wrap">
                <div className="callback-info-subtitle">
                  <h4>Get in touch</h4>
                </div>
                <div className="callback-info-title">
                  <h2>Call anytime to book your cab</h2>
                </div>
                <div className="callback-info-description">
                  <p>Get in touch with us today for all your travel needs</p>
                </div>
                <div className="callback-info-button">
                  <button
                    className="call-now-btn"
                    onClick={() => handleCallNow('https://wa.me/918007722929?text=I%20want%20to%20book%20a%20cab')}
                  >
                    <i className="fas fa-phone-alt"></i>
                    <span>Book Now</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
